import { render, staticRenderFns } from "./ResultBlock.vue?vue&type=template&id=148471ff&scoped=true&"
import script from "./ResultBlock.vue?vue&type=script&lang=ts&"
export * from "./ResultBlock.vue?vue&type=script&lang=ts&"
import style0 from "./ResultBlock.vue?vue&type=style&index=0&id=148471ff&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "148471ff",
  null
  
)

export default component.exports